// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import Button from 'components/common/Button';
import AdminHeader from 'components/common/AdminHeader';
import InviteForm from 'components/forms/InviteForm';
import AdminUsersTable from './AdminUsersTable';
import DownloadUsersButton from './DownloadUsersButton';
import DownloadActiveUsers from './DownloadActiveUsers';
// APOLLO
import getUsersAdminQuery from 'ApolloClient/Queries/getUsersAdmin';
import adminCreateUser from 'ApolloClient/Mutations/adminCreateUser';
import { compose, Query, graphql } from 'react-apollo';
// LIB
import ErrorHelpers from 'lib/helpers/ErrorHelpers';
import message from 'components/common/message';
// COMPONENTS
import SearchBox from 'components/inputs/SearchBox';

class AdminUsers extends React.PureComponent {
  state = {
    showAddUserForm: false,
    searchText: null,
    loading: false,
    skip: 0,
    limit: 5,
  };

  toggleForm = () => {
    this.setState({ showAddUserForm: !this.state.showAddUserForm });
  };

  handleSubmit = ({ email, firstName, lastName, infusionsoftId }) => {
    const params = {
      email,
      firstName,
      lastName,
      infusionsoftId,
    };
    this.props
      .createUser({
        variables: { params },
        // refetchQueries: [{ query: User.Query.getUsers, variables: {} }],
      })
      .then(() => {
        this.setState({ showAddUserForm: false });
        message.success('user created successfully!');
      })
      .catch(err => ErrorHelpers.handleError(err));
  };

  onPageChange = ({ current, pageSize }) => {
    this.setState({ limit: current * pageSize });
  };

  render() {
    return (
      <PageContainer>
        <React.Fragment>
          {!this.state.showAddUserForm ? (
            <React.Fragment>
              <AdminHeader
                header="Users"
                action={
                  <Button fullWidth style={{ marginBottom: 20 }} onClick={this.toggleForm}>
                    + ADD USER
                  </Button>
                }
              />
              <Query
                query={getUsersAdminQuery}
                variables={{
                  params: { searchText: this.state.searchText, limit: this.state.limit },
                }}
              >
                {({ data, networkStatus, loading }) => {
                  if (loading && networkStatus !== 2) return 'loading';
                  return (
                    <React.Fragment>
                      <div style={{ width: '50%', marginBottom: 10 }}>
                        <SearchBox
                          value={this.state.searchText}
                          onChange={searchText => this.setState({ searchText })}
                        />
                      </div>
                      <AdminUsersTable
                        onChange={this.onPageChange}
                        loading={networkStatus === 2}
                        total={data.getUsersAdmin.count}
                        users={data.getUsersAdmin.users}
                      />
                      <DownloadUsersButton />
                      <div style={{ height: 20 }} />
                      <DownloadActiveUsers />
                    </React.Fragment>
                  );
                }}
              </Query>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <AdminHeader
                header="Add New User"
                action={
                  <Button fullWidth type="dashed" style={{ marginBottom: 20 }} onClick={this.toggleForm}>
                    Close
                  </Button>
                }
              />
              <div style={{ width: 500, maxWidth: '100%' }}>
                <InviteForm handleSubmit={this.handleSubmit} />
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      </PageContainer>
    );
  }
}

export default compose(
  graphql(adminCreateUser, { name: 'createUser' }),
  // graphql(getUsersAdminQuery, { name: 'getUsersAdminQuery' }),
  // RecomposeHelpers.errorHOC({ propName: 'getUsersAdminQuery' }),
)(AdminUsers);



// WEBPACK FOOTER //
// ./src/routes/admin-users/index.js